module.exports = __webpack_public_path__ + "./fonts/85f9a2bfb51f102516b9874c98d14aac.otf";